import { Injectable } from '@angular/core';
import { ConfirmationService as PrimengConfirmationService } from 'primeng/api';
import { LanguageService } from '../../core/services/language.service';
import { Confirmation } from '../components/overlay/confirm-dialog/contract/confirm-dialog-confirmation.contract';

@Injectable({
  providedIn: 'root',
})
export class ConfirmationService {
  constructor(
    private confirmationService: PrimengConfirmationService,
    private languageService: LanguageService,
  ) { }

  public confirm(confirmation: Confirmation): void {
    this.confirmationService.confirm({
      key: 'root-confirm-dialog',
      acceptIcon: 'none',
      rejectIcon: 'none',
      acceptLabel: this.translate('general.buttons.yes'),
      rejectLabel: this.translate('general.buttons.no'),
      rejectButtonStyleClass: 'p-button-outlined p-button-secondary',
      acceptButtonStyleClass: 'p-button-danger',
      ...confirmation,
    });
  }

  public close(): void {
    this.confirmationService.close();
  }

  public onAccept(): void {
    this.confirmationService.onAccept();
  }

  private translate(key: string): string {
    return this.languageService.getInstant(key);
  }
}
